
export const REPORT_CREATE_SESSION_REQUEST = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        createSession: true,
      },
      error: null,
    },
  };
};

export const REPORT_CREATE_SESSION_SUCCESS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        id: action.payload.sessionId,
        status: 'configuring',
      },
      fetching: {
        ...state.reportGenerator.fetching,
        createSession: false,
      },
    },
  };
};

export const REPORT_CREATE_SESSION_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        createSession: false,
      },
      error: action.payload,
    },
  };
};

export const REPORT_FINISH_SESSION_REQUEST = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        status: 'generating',
      },
    },
  };
};

export const REPORT_FINISH_SESSION_SUCCESS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        status: 'completed',
      },
      createdDocument: action.payload,
    },
  };
};

export const REPORT_FINISH_SESSION_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        status: 'error',
      },
      error: action.payload,
    },
  };
};

export const REPORT_SET_SELECTED_FORMS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      selectedForms: action.payload,
    },
  };
};

export const REPORT_SET_SELECTED_PATIENTS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      selectedPatients: action.payload,
      configuration: {
        ...state.reportGenerator.configuration,
        clientFilter: {
          ...state.reportGenerator.configuration.clientFilter,
          selectedClients: action.payload,
        },
      },
    },
  };
};

export const REPORT_FETCH_PATIENTS_REQUEST = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchPatients: true,
      },
    },
  };
};

export const REPORT_FETCH_PATIENTS_SUCCESS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      patientsList: action.payload,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchPatients: false,
      },
    },
  };
};

export const REPORT_FETCH_PATIENTS_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchPatients: false,
      },
      error: action.payload,
    },
  };
};

export const REPORT_FETCH_FORMS_LIST_REQUEST = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchForms: true,
      },
    },
  };
};

export const REPORT_FETCH_FORMS_LIST_SUCCESS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      formsList: action.payload,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchForms: false,
      },
    },
  };
};

export const REPORT_FETCH_FORMS_LIST_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchForms: false,
      },
      error: action.payload,
    },
  };
};

export const REPORT_SET_CONFIGURATION = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      configuration: {
        ...state.reportGenerator.configuration,
        ...action.payload,
      },
    },
  };
};

export const REPORT_SET_ANALYSIS_TYPE = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      configuration: {
        ...state.reportGenerator.configuration,
        analysisType: action.payload,
      },
    },
  };
};

export const REPORT_SET_DATE_FILTER = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      configuration: {
        ...state.reportGenerator.configuration,
        dateFilter: {
          ...state.reportGenerator.configuration.dateFilter,
          ...action.payload,
        },
      },
    },
  };
};

export const REPORT_SET_CLIENT_FILTER = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      configuration: {
        ...state.reportGenerator.configuration,
        clientFilter: {
          ...state.reportGenerator.configuration.clientFilter,
          ...action.payload,
        },
      },
    },
  };
};

export const REPORT_START_GENERATION = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        status: 'generating',
        progress: 0,
      },
      fetching: {
        ...state.reportGenerator.fetching,
        generateReport: true,
      },
    },
  };
};

export const REPORT_UPDATE_PROGRESS = (state, action) => {

  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        progress: action.payload.progress,
        currentStep: action.payload.currentStep || state.reportGenerator.session.currentStep,
      },
    },
  };
};

export const REPORT_RESET_STATE_MODAL_PROGRESS = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      selectedPatients: [],
      session: {
        currentStep: '',
        progress: 0,
      },
    },
  };
};

export const REPORT_GENERATION_SUCCESS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        status: 'completed',
      },
      generatedContent: action.payload,
      fetching: {
        ...state.reportGenerator.fetching,
        generateReport: false,
      },
    },
  };
};

export const REPORT_GENERATION_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        status: 'error',
      },
      fetching: {
        ...state.reportGenerator.fetching,
        generateReport: false,
      },
      error: action.payload,
    },
  };
};

export const REPORT_WEBSOCKET_CONNECTED = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      websocket: {
        ...state.reportGenerator.websocket,
        connected: true,
        error: null,
      },
    },
  };
};

export const REPORT_WEBSOCKET_DISCONNECTED = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      websocket: {
        ...state.reportGenerator.websocket,
        connected: false,
      },
    },
  };
};

export const REPORT_WEBSOCKET_MESSAGE = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      generatedContent: action.payload,
    },
  };
};

export const REPORT_WEBSOCKET_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      websocket: {
        ...state.reportGenerator.websocket,
        connected: false,
        error: action.payload,
      },
    },
  };
};

export const REPORT_FETCH_ANSWERS_REQUEST = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      session: {
        ...state.reportGenerator.session,
        status: 'fetching-answers',
      },
      fetching: {
        ...state.reportGenerator.fetching,
        fetchAnswers: true,
      },
    },
  };
};

export const REPORT_FETCH_ANSWERS_SUCCESS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      formAnswers: action.payload,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchAnswers: false,
      },
    },
  };
};

export const REPORT_FETCH_ANSWERS_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchAnswers: false,
      },
      error: action.payload,
    },
  };
};

export const REPORT_CREATE_DOCUMENT_REQUEST = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        createDocument: true,
      },
    },
  };
};

export const REPORT_CREATE_DOCUMENT_SUCCESS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      createdDocument: action.payload,
      fetching: {
        ...state.reportGenerator.fetching,
        createDocument: false,
      },
    },
  };
};

export const REPORT_CREATE_DOCUMENT_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        createDocument: false,
      },
      error: action.payload,
    },
  };
};

export const REPORT_RESET_STATE = (state) => {
  const initialState = require('./initialState').default;
  return {
    ...state,
    reportGenerator: initialState,
  };
};

export const REPORT_CLEAR_ERROR = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      error: null,
    },
  };
};

export const REPORT_FETCH_TEMPLATES_REQUEST = (state) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchTemplates: true,
      },
    },
  };
};

export const REPORT_FETCH_TEMPLATES_SUCCESS = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      reportTemplates: action.payload,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchTemplates: false,
      },
    },
  };
};

export const REPORT_FETCH_TEMPLATES_ERROR = (state, action) => {
  return {
    ...state,
    reportGenerator: {
      ...state.reportGenerator,
      fetching: {
        ...state.reportGenerator.fetching,
        fetchTemplates: false,
      },
      error: action.payload,
    },
  };
};
